module.exports = __webpack_public_path__ + "img/slika12.ff9788e4.jpg";